export const countries = [
  "India",
  "United States",
  "United Kingdom",
  "Canada",
  "Australia",
  "United Arab Emirates",
  "Saudi Arabia",
  "Singapore",
  "Malaysia",
  "Thailand",
  "Indonesia",
  "Philippines",
  "Vietnam",
  "Japan",
  "South Korea",
  "China",
  "Hong Kong",
  "Taiwan",
  "Germany",
  "France",
  "Italy",
  "Spain",
  "Netherlands",
  "Belgium",
  "Switzerland",
  "Austria",
  "Sweden",
  "Norway",
  "Denmark",
  "Finland",
  "Ireland",
  "Portugal",
  "Greece",
  "Poland",
  "Czech Republic",
  "Hungary",
  "Romania",
  "Russia",
  "South Africa",
  "Kenya",
  "Nigeria",
  "Egypt",
  "Morocco",
  "Brazil",
  "Argentina",
  "Mexico",
  "Chile",
  "Colombia",
  "Peru",
  "New Zealand",
  "Fiji",
  "Bangladesh",
  "Pakistan",
  "Sri Lanka",
  "Nepal",
  "Maldives",
  "Bhutan",
  "Afghanistan",
  "Iran",
  "Iraq",
  "Israel",
  "Jordan",
  "Kuwait",
  "Lebanon",
  "Oman",
  "Qatar",
  "Bahrain",
  "Yemen",
  "Turkey",
  "Kazakhstan",
  "Uzbekistan"
];

export const getShippingCost = (country) => {
  if (country.toLowerCase() === "india") {
    return 0;
  }
  return 2500; // Flat rate for international
};
